export enum AlarmEventType {
    Unknown = 0,

    // Information about triggered alarm (1000-1999)
    AnalysisAlarm = 1100,
    VideoMotionAlarm = 1101,
    ExternalInputAlarm = 1900,

    ScheduledAlarm = 1200,
    ScheduledRemotePatrol = 1201,
    ScheduledMindCarePatrol = 1202,

    // Insert into queue on server/cloud (3000-3999)
    QueueInserted = 3101,

    // New alarm central flow [Mindcare] (10000-19999)
    Reserved = 10001,
    ReservationRemoved = 10002,
    Overdue = 10003,

    HandlingCompleted = 11001,

    VideoStarted = 12001,
    ListenedThroughCamera = 12002,
    SpokeThroughCamera = 12003,
    InformationSaved = 12004,
    Snoozed = 12005,

    DetailsAccessed = 13001,
}
